
import { Component, Prop, Vue } from "vue-property-decorator";
import KeyManagersTable from "@/components/keys/managers/KeyManagersTable.vue";

@Component({
  components: { KeyManagersTable },
})
export default class KeyManagersTab extends Vue {

  @Prop({default: null})
  public currentKey: any;

  get isManager(): boolean {
    return !!this.currentKey?.legitimateKeyAccess?.keyManagementId;
  }

  get isCompanyBlocked(): boolean {
    return !!this.currentKey?.company?.blockedAt;
  }

  get isArchived(): boolean {
    return this.currentKey.status === "ARCHIVED";
  }
}
